import React from 'react';
import { Button, MessageDialog } from '../../../Core/';
import { IconLock } from '../../../../Lib/Icons';

// Component that provides a status icon for the worksheet
const WorksheetGridWorksheetStatusIcon = ({ status }) => {
  return status.readonly.locked ? (
    <MessageDialog messageTitle="Worksheet Locked" messageText={status.readonly.lockedMessage} alwaysEnabled>
      <Button subtle noPadding alwaysEnabled>
        <IconLock size="1.5em" />
      </Button>
    </MessageDialog>
  ) : null;
};

export default WorksheetGridWorksheetStatusIcon;
export { WorksheetGridWorksheetStatusIcon };
